<iframe [src]="trustedSrc" allow="camera *; microphone *;"></iframe>

<studio-button-legacy class="close-button" theme="primary" isIconOnly="true" (click)="close()">
  <studio-icon name="close" title="Close"></studio-icon>
</studio-button-legacy>
